import Glide, {
    Autoplay,
    Controls,
    Keyboard,
    Swipe,
} from '@glidejs/glide/dist/glide.modular.esm';
import $ from '../lib/jquery';

export class Slider {
    selector = '';

    $element = null;

    slider = null;

    $playPause = null;

    playing = true;

    options = {
        type: 'slider',
        focusAt: 'center',
        gap: 0,
        animationTimingFunc: 'ease-in-out',
        autoplay: 4000,
        classes: {
            activeNav: 'is-active',
        },
    };

    constructor(selector, options = {}) {
        this.selector = selector;
        this.options = {
            ...this.options,
            ...options,
        };
        this.$element = $(this.selector);
        this.$playPause = this.$element.find('.js-slider-toggle');
        this.init();
    }

    init() {
        this.slider = new Glide(this.selector, this.options);

        this.slider = this.slider.mount({
            Autoplay,
            Controls,
            Keyboard,
            Swipe,
        });

        this.$playPause.on('click', this.toggle);

        $(`${this.selector} a`).on('focus', this.onLinkFocus);
    }


    onChange(callback) {
        this.slider.on('run', (info) => {
            callback(this.slider, info);
        });
    }

    onLinkFocus = (evt) => {
        this.pause();
        const $slide = $(evt.currentTarget).closest('.js-slider-slide');

        const slideIndex = $slide.data('slide');

        if (slideIndex !== this.slider.index) {
            this.slider.go(`=${slideIndex}`);
        }
    };

    toggle = () => {
        if (this.playing) {
            this.pause();
            return;
        }

        this.play();
    };

    pause = () => {
        this.playing = false;
        this.slider.update({ autoplay: false });

        this.$playPause.removeClass('is-playing');
        this.$playPause.addClass('is-paused');
        this.$playPause.attr('aria-label', this.$playPause.data('pause-text'));
    };

    play = () => {
        this.playing = true;
        this.slider.update({ autoplay: this.options.autoplay });

        this.$playPause.removeClass('is-paused');
        this.$playPause.addClass('is-playing');
        this.$playPause.attr('aria-label', this.$playPause.data('play-text'));
    };
}



// WEBPACK FOOTER //
// ./assets/js/core/slider.js